import * as React from 'react';
import {Route, Switch} from 'react-router-dom';
import * as routes from '../../util/routes';
import {
  PPIList,
  PPIDetail
} from '../../component/ppi';

export default class PPIComponent extends React.Component {
  render() {
    return (
      <Switch>
				<Route exact path={routes.LOCAL_AUTHORITY_PATTERN + routes.PPI} render={props => 
					<PPIDetail {...props} />
				}/>
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/route/secured/ppi.js